import { render } from "./Blank.vue?vue&type=template&id=73ca8132"
const script = {}
script.render = render

export default script